import { Button, ButtonLevel, Tooltip, TooltipTrigger } from '@vizit/atoms';
import { cva, cx } from '@vizit/theme';
import type { VerticalNavbarOrgBadgeConfig } from './types';

const styles = cva({
  base: ['flex items-center justify-center', 'w-18 h-12 rounded-none px-0 py-0', 'text-xs font-medium'],
  variants: {
    hasCustomColors: {
      false: 'bg-pink-200 text-primary',
    },
  },
  defaultVariants: {
    hasCustomColors: false,
  },
});

interface VerticalNavbarOrgBadgeProps extends VerticalNavbarOrgBadgeConfig {
  className?: string;
}

function VerticalNavbarOrgBadge(props: VerticalNavbarOrgBadgeProps) {
  const { name, backgroundColor, textColor, className } = props;
  const initials = name.slice(0, 2).toUpperCase();
  const hasCustomColors = Boolean(backgroundColor || textColor);

  return (
    <TooltipTrigger delay={300}>
      <Button
        level={ButtonLevel.Ghost}
        aria-label={`Organization: ${name}`}
        className={cx(styles({ hasCustomColors }), className)}
        style={{
          ...(backgroundColor && { backgroundColor }),
          ...(textColor && { color: textColor }),
        }}
      >
        {initials}
      </Button>
      <Tooltip placement="right">{name}</Tooltip>
    </TooltipTrigger>
  );
}

export { VerticalNavbarOrgBadge };
export type { VerticalNavbarOrgBadgeProps };
